import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import SecondaryResourcesCategoryView from "./SecondaryResourcesCategoryView"
import Prep2TB from "../images/prep-2.jpg"
import ZipLogo from "../images/zip.svg"

class Prep2Resources extends React.Component {
  state = {
    view: {
      title: "Preparatory 2 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Prep2TB,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-prep-2-sep-2023/Grade+8+Preparatory+2+TB_at+level_WM.pdf",
        },
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-prep-2-sep-2023/",
          files: [
            {
              name: "Preparatory 2 Audio",
              file: "Preparatory+2+Audio+Tracks+2022-2023.zip",
            },
          ],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <SecondaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Prep2Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesPrep2.js